import { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { statementDataModel } from "./statementDataModel";
import { StatementResult } from "@/views/contract/manage/ContractManageTypes";
import { formatLocalDateTime } from "@/utils/utils";

export function StatementDataTable() {

    const {
        loading, dataSource, pgCfg,
        loadData, setSelectedRowKeys,
    } = statementDataModel();

    const columns: ColumnsType<StatementResult> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '合约单号',
            dataIndex: 'contractCode',
            align: "center",
            width: 140,
            ellipsis: true,
        },
        {
            title: '对账单号',
            dataIndex: 'code',
            align: "center",
            ellipsis: true,
        },
        {
            title: '账单生成日期',
            dataIndex: 'createTime',
            align: "center",
            ellipsis: true,
            render: (text) => formatLocalDateTime(text)
        },
        {
            title: '账单金额',
            dataIndex: 'amount',
            align: "center",
            ellipsis: true,
        }
    ];

    useEffect(() => {
        loadData().then();
    }, [])

    return (
        <Table
            loading={loading}
            rowKey={record => record.contractCode}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.contractCode]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

